module.exports = __webpack_public_path__ + "images/new-products/ECOLD-VTS-5dc36bb208fdd00de08b1698c53152ce.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/new-products/ECOLD-VTS.jpg
 ** module id = 288
 ** module chunks = 0
 **/